const SUGGESTED_TITLE_CHARACTERS = 60;

/** A title to start from: the passage's first words, cut at a word and on one line. */
export function suggestedMemoryTitle(passage: string): string {
  const plain = passage.replace(/\s+/g, " ").replace(/[*_`#>]/g, "").trim();
  const line = plain.charAt(0).toUpperCase() + plain.slice(1);
  if (line.length <= SUGGESTED_TITLE_CHARACTERS) {
    return line;
  }
  const cut = line.slice(0, SUGGESTED_TITLE_CHARACTERS);
  const atWord = cut.lastIndexOf(" ");
  return `${(atWord > SUGGESTED_TITLE_CHARACTERS / 2 ? cut.slice(0, atWord) : cut).trimEnd()}…`;
}
